// extracted by mini-css-extract-plugin
module.exports = {"ldSpinner":"SpinLoader_ldSpinner__ZfBUw","skeleton-loading":"SpinLoader_skeleton-loading__FwbTH"};